import { render, staticRenderFns } from "./AuthenticatedLayout.vue?vue&type=template&id=97b9e7b2&"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticatedLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports